import { AppState } from "features";
import { createSelector } from "reselect";

const posSync = (state: AppState) => state.catalogue.posSync;

// note: this selector retrieves the catalogue.posSync operation state; not whether posSync is enabled @see getPosSyncEnabled
export const getPosSync = createSelector(posSync, (posSync) => posSync);
